export default {
  name: 'default',

  load: ({ id, files, typeHandlers }) => {
    const file = files[id];
    return file ? typeHandlers[file.type](id, file) : null;
  }
};
